import { whiteListRegexOnlyLettersAndCertainChars } from '@chegg/commerce-utils';

/**
 * Function scrubCardholderName removes all non-alphabet characters but allows for `'~.-
 * and truncates the string to only 30 chars long.
 * @param { string } cardholderName
 * @returns { string }
 */
export var scrubCardholderName = function scrubCardholderName(cardholderName) {
  return cardholderName.replace(whiteListRegexOnlyLettersAndCertainChars, '').substring(0, 30);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/utils/hostedFieldUtil.js
// module id = 1739
// module chunks = 11